import ClientCreateScreen from './ClientCreateScreen';

export default ClientCreateScreen;
